import React, { memo } from "react";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserDropdown from "components/dropdowns/UserDropdown";
import { Row, Card, Form, Col, InputGroup, Button } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import Rating from "react-rating";

const Filters = ({ filters, setFilters, handleClick }) => {
    return (
        <Card className="p-3">
            <Form.Group as={Row} className="p-2">
                <Col xs={3}>
                    <Form.Label>Date</Form.Label>
                    <InputGroup>
                        <Col xs={5}>
                            <DatePicker
                                calendarStartDay={1}
                                id="date-from"
                                className="form-control text-center"
                                placeholderText="Select From"
                                onChange={date => setFilters({ ...filters, start: new Date(date).toISOString() })}
                                dateFormat={'dd/MM/yyyy'}
                                selected={filters?.start ? new Date(filters?.start) : new Date()}
                                isClearable
                            />
                        </Col>
                        <Col xs={2}>
                            <InputGroup.Text>To</InputGroup.Text>
                        </Col>
                        <Col xs={5}>
                            <DatePicker
                                calendarStartDay={1}
                                id="date-to"
                                className="form-control text-center"
                                placeholderText="Select To"
                                onChange={date => setFilters({ ...filters, end: new Date(date).toISOString() })}
                                dateFormat={'dd/MM/yyyy'}
                                selected={filters?.end ? new Date(filters?.end) : new Date()}
                                isClearable
                            />
                        </Col>
                    </InputGroup>
                </Col>
                <Col xs={3}>
                    <Form.Label>Search</Form.Label>
                    <Form.Control
                        value={filters?.query}
                        type="text"
                        onChange={e => setFilters({ ...filters, query: e.target.value.trim() })}
                        placeholder="Search questions or answers"
                    ></Form.Control>
                </Col>
                <Col xs={3}>
                    <Form.Label>Users</Form.Label>
                    <UserDropdown
                        handleChange={e => setFilters({ ...filters, users: e })}
                        selectedOptions={filters?.users}
                    />
                </Col>
                <Col xs={2}>
                    <Form.Label>Rating</Form.Label>
                    <Col xs={12}>
                        <Rating
                            initialRating={filters.rating}
                            value={filters.rating}
                            fullSymbol={<FontAwesomeIcon icon="star" className="text-primary me-1" />}
                            emptySymbol={<FontAwesomeIcon icon="star" className="text-300 me-1" />}
                            onChange={e => setFilters({ ...filters, rating: e })}
                        />
                        <Button size="sm" variant="outline-primary border-0" onClick={() => setFilters({ ...filters, rating: 0 })}>
                            Clear
                        </Button>
                    </Col>
                    <Col xs={6} className="d-flex justify-content-between">
                        <Form.Label title="Search selected range"><small>Range</small></Form.Label>
                        <Form.Check
                            type='switch'
                            checked={filters?.exactRating}
                            onChange={e => setFilters({ ...filters, exactRating: e.target.checked })}
                        />
                        <Form.Label title="Search exact match"><small>Exact</small></Form.Label>
                    </Col>
                </Col>
                <Col xs={1}>
                    <Button onClick={handleClick}>Search</Button>
                </Col>
            </Form.Group>
        </Card >
    )
}

Filters.propTypes = {
    filters: PropTypes.object,
    setFilters: PropTypes.func,
    handleClick: PropTypes.func
};

export default memo(Filters);